import '@fontsource-variable/inter';
import '@fontsource/poppins/100.css';
import '@fontsource/poppins/200.css';
import '@fontsource/poppins/300.css';
import '@fontsource/poppins/400.css';
import '@fontsource/poppins/500.css';
import '@fontsource/poppins/600.css';
import '@fontsource/poppins/700.css';
import '@fontsource/poppins/800.css';
import '@fontsource/poppins/900.css';
import 'vue-sonner/style.css';

import ApplicationLayout from '@/layouts/ApplicationLayout.vue';
import { createInertiaApp } from '@inertiajs/vue3';

import { createPinia } from 'pinia';
import { createSSRApp, DefineComponent, h } from 'vue';
import { createI18n } from 'vue-i18n';
import enUS from '../../../config/locales/en-us.json';
import ptBR from '../../../config/locales/pt-br.json';

const i18n = createI18n({
  locale: 'pt-BR',
  fallbackLocale: 'pt-BR',
  messages: {
    'pt-BR': ptBR,
    'en-US': enUS
  }
})

const pinia = createPinia()

createInertiaApp({
  progress: {
    color: '#F69320',
    showSpinner: true,
  },
  resolve: (name) => {
    const pages = import.meta.glob<DefineComponent>('../pages/**/*.vue', {
      eager: true,
    })
    const page = pages[`../pages/${name}.vue`]
    if (!page) throw new Error(`[Inertia] Page component not found: "${name}"`)
    page.default.layout = page.default.layout || ApplicationLayout
    return page

  },

  setup({ el, App, props, plugin }) {
    createSSRApp({ render: () => h(App, props) })
      .use(i18n)
      .use(pinia)
      .use(plugin)
      .mount(el)
  },
})
